import { MuiThemeProvider } from '@material-ui/core';
import { AppProvider } from './providers/app.provider';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import theme from './app.theme';
import './assets/styles/style.scss';
import LayoutComponent from './components/Layout/layout.component';
import AppErrorBoundary from './error-boundary.component';
import { AppRoutes } from './app.routes';

class AppComponent extends React.Component<any, any> {
	public render() {
		return (
			<MuiThemeProvider theme={theme}>
				<AppErrorBoundary>
					<AppProvider>
						<CssBaseline />
						<LayoutComponent>
							<AppRoutes />
						</LayoutComponent>
					</AppProvider>
				</AppErrorBoundary>
			</MuiThemeProvider>
		);
	}
}

export default withRouter(AppComponent);